/* DAL · Designer Alterations — shared behaviour for all DAL sections.
   Safe to include from several sections: runs once, re-inits on theme editor events. */
(function () {
  'use strict';
  if (window.DAL) return;
  var DAL = (window.DAL = {});
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function qa(root, sel) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function each(root, sel, fn) {
    var list = qa(root, sel);
    if (root && root.matches && root.matches(sel)) list.unshift(root);
    list.forEach(fn);
  }

  /* ---------- Tape-measure ruler ---------- */
  function drawRuler(c) {
    var d = c.dataset, dpr = window.devicePixelRatio || 1;
    var w = c.clientWidth, h = c.clientHeight;
    if (!w || !h) return;
    c.width = Math.round(w * dpr); c.height = Math.round(h * dpr);
    var x = c.getContext('2d');
    x.setTransform(dpr, 0, 0, dpr, 0, 0);
    x.clearRect(0, 0, w, h);
    var top = Math.round(h * 0.17), band = h - top * 2;
    var sp = Math.max(4, parseInt(d.spacing, 10) || 8);
    x.fillStyle = d.fill || '#ECE6D8'; x.fillRect(0, top, w, band);
    x.strokeStyle = d.line || '#8A8578'; x.lineWidth = 1;
    x.beginPath(); x.moveTo(0, top + 0.5); x.lineTo(w, top + 0.5);
    x.moveTo(0, top + band - 0.5); x.lineTo(w, top + band - 0.5); x.stroke();
    x.fillStyle = d.tick || '#1B1B18';
    x.font = '10px "Space Mono", ui-monospace, monospace';
    for (var i = 0, px = 0; px < w; i++, px += sp) {
      var len = i % 10 === 0 ? band * 0.47 : (i % 5 === 0 ? band * 0.3 : band * 0.17);
      x.fillRect(Math.round(px) + 0.5, top + 1, 1, len);
      if (d.numbers === 'true' && i % 10 === 0 && i > 0) x.fillText(String(i / 10), px + 3, top + band - 5);
    }
  }
  function initRulers(root) { each(root, '[data-dal-ruler]', drawRuler); }

  /* ---------- Stitch rail + sticky subnav highlight ---------- */
  function onScroll() {
    var h = document.documentElement, max = h.scrollHeight - h.clientHeight;
    var pct = max > 0 ? (h.scrollTop / max) * 100 : 0;
    qa(document, '[data-dal-rail]').forEach(function (r) { r.style.width = pct + '%'; });
    qa(document, '[data-dal-subnav]').forEach(function (nav) {
      var links = qa(nav, '[data-dal-navlink]'), cur = -1;
      links.forEach(function (a, i) {
        var id = (a.getAttribute('href') || '').replace('#', '');
        var t = id && document.getElementById(id);
        if (t && t.getBoundingClientRect().top < 160) cur = i;
      });
      links.forEach(function (a, i) {
        a.classList.toggle('is-active', i === cur);
        if (i === cur) a.setAttribute('aria-current', 'location'); else a.removeAttribute('aria-current');
      });
    });
  }

  /* ---------- Hero ticket ---------- */
  function initTicket(el) {
    clearInterval(el._dalTimer);
    var slides = qa(el, '[data-dal-slide]'), dots = qa(el, '[data-dal-dot]');
    if (!slides.length) return;
    function show(i) {
      el._dalIndex = i;
      slides.forEach(function (s, j) { s.hidden = j !== i; });
      dots.forEach(function (b, j) { b.setAttribute('aria-current', j === i ? 'true' : 'false'); });
    }
    function stop() { clearInterval(el._dalTimer); }
    el._dalShow = function (i) { stop(); show(i); };
    dots.forEach(function (b, j) { b.onclick = function () { el._dalShow(j); }; });
    el.onmouseenter = stop;
    if (!el._dalBound) {
      el._dalBound = true;
      el.addEventListener('focusin', function () { clearInterval(el._dalTimer); });
    }
    show(0);
    var ms = parseInt(el.dataset.interval, 10) || 5000;
    if (!reduce && el.dataset.autoplay === 'true' && slides.length > 1) {
      el._dalTimer = setInterval(function () { show((el._dalIndex + 1) % slides.length); }, ms);
    }
  }

  /* ---------- House register ---------- */
  function initRegister(el) {
    var tabs = qa(el, '[data-dal-house]'), panels = qa(el, '[data-dal-panel]');
    if (!tabs.length) return;
    el._dalTab = el._dalTab || 'jobs';
    function applyTab(panel) {
      if (!panel) return;
      var btns = qa(panel, '[data-dal-tab]');
      if (!btns.length) return;
      var keys = btns.map(function (b) { return b.dataset.dalTab; });
      var k = keys.indexOf(el._dalTab) > -1 ? el._dalTab : keys[0];
      btns.forEach(function (b) {
        var on = b.dataset.dalTab === k;
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
      });
      qa(panel, '[data-dal-tabbody]').forEach(function (b) { b.hidden = b.dataset.dalTabbody !== k; });
    }
    function select(i, focus) {
      tabs.forEach(function (t, j) {
        t.setAttribute('aria-selected', j === i ? 'true' : 'false');
        t.tabIndex = j === i ? 0 : -1;
      });
      panels.forEach(function (p, j) { p.hidden = j !== i; });
      applyTab(panels[i]);
      if (focus) tabs[i].focus();
    }
    el._dalSelect = select;
    tabs.forEach(function (t, i) {
      t.onclick = function () { select(i); };
      t.onkeydown = function (e) {
        var n = null;
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') n = (i + 1) % tabs.length;
        if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
        if (e.key === 'Home') n = 0;
        if (e.key === 'End') n = tabs.length - 1;
        if (n !== null) { e.preventDefault(); select(n, true); }
      };
    });
    panels.forEach(function (p) {
      qa(p, '[data-dal-tab]').forEach(function (b) {
        b.onclick = function () { el._dalTab = b.dataset.dalTab; applyTab(p); };
      });
    });
    var def = parseInt(el.dataset.default, 10) || 0;
    select(Math.min(Math.max(def, 0), tabs.length - 1));
  }

  /* ---------- Before / after slider ---------- */
  function initBA(el) {
    var range = el.querySelector('[data-dal-ba-range]');
    if (!range) return;
    function set() { el.style.setProperty('--dal-pos', range.value + '%'); }
    range.oninput = set; set();
  }

  /* ---------- Estimator ---------- */
  function initEstimator(el) {
    var d = el.dataset;
    var radios = qa(el, '[data-dal-garment]'), groups = qa(el, '[data-dal-works]');
    var hand = el.querySelector('[data-dal-hand]');
    var priceEl = el.querySelector('[data-dal-price]'), daysEl = el.querySelector('[data-dal-days]'), linesEl = el.querySelector('[data-dal-lines]');
    function money(n) { return (d.currency || '$') + n; }
    function calc() {
      var r = radios.filter(function (x) { return x.checked; })[0] || radios[0];
      var g = r ? r.value : '0', total = 0, lines = [];
      groups.forEach(function (gr) { gr.hidden = gr.dataset.dalWorks !== g; });
      var grp = groups.filter(function (x) { return x.dataset.dalWorks === g; })[0];
      if (grp) qa(grp, 'input:checked').forEach(function (i) {
        var p = parseFloat(i.dataset.price) || 0; total += p; lines.push([i.dataset.label, p]);
      });
      var pct = parseFloat(d.hand) || 0;
      if (hand && hand.checked && total && pct) {
        var extra = Math.round((total * pct) / 100 / 5) * 5;
        if (extra) { total += extra; lines.push([d.handLabel || 'Hand finishing', extra]); }
      }
      if (priceEl) priceEl.textContent = total ? ((d.prefix ? d.prefix + ' ' : '') + money(total)) : money(0);
      if (daysEl) daysEl.textContent = total ? ((d.readyPrefix || '') + ' ' + (r && r.dataset.days ? r.dataset.days : '')).trim() : (d.prompt || '');
      if (linesEl) {
        linesEl.innerHTML = '';
        if (!lines.length) {
          var li0 = document.createElement('li'); li0.className = 'is-empty'; li0.textContent = d.empty || ''; linesEl.appendChild(li0);
        }
        lines.forEach(function (l) {
          var li = document.createElement('li'), a = document.createElement('span'), b = document.createElement('span');
          a.textContent = l[0]; b.textContent = money(l[1]); li.appendChild(a); li.appendChild(b); linesEl.appendChild(li);
        });
      }
    }
    el.onchange = calc;
    calc();
  }

  /* ---------- Reviews carousel ---------- */
  function initReviews(el) {
    var track = el.querySelector('[data-dal-track]');
    if (!track) return;
    function slide(dir) {
      var card = track.firstElementChild; if (!card) return;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 24;
      track.scrollBy({ left: dir * (card.offsetWidth + gap), behavior: reduce ? 'auto' : 'smooth' });
    }
    var prev = el.querySelector('[data-dal-prev]'), next = el.querySelector('[data-dal-next]');
    if (prev) prev.onclick = function () { slide(-1); };
    if (next) next.onclick = function () { slide(1); };
  }

  /* ---------- Init / teardown ---------- */
  function init(root) {
    root = root || document;
    initRulers(root);
    each(root, '[data-dal-ticket]', initTicket);
    each(root, '[data-dal-register]', initRegister);
    each(root, '[data-dal-ba]', initBA);
    each(root, '[data-dal-estimator]', initEstimator);
    each(root, '[data-dal-reviews]', initReviews);
    onScroll();
  }
  function destroy(root) { each(root, '[data-dal-ticket]', function (t) { clearInterval(t._dalTimer); }); }
  DAL.init = init;

  window.addEventListener('scroll', onScroll, { passive: true });
  var rt;
  window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { initRulers(document); onScroll(); }, 120); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { initRulers(document); });

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { destroy(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var b = e.target;
    if (!b || !b.closest) return;
    var ticket = b.closest('[data-dal-ticket]');
    if (ticket && b.hasAttribute('data-dal-slide') && ticket._dalShow) ticket._dalShow(qa(ticket, '[data-dal-slide]').indexOf(b));
    var reg = b.closest('[data-dal-register]');
    if (reg && b.hasAttribute('data-dal-house') && reg._dalSelect) reg._dalSelect(qa(reg, '[data-dal-house]').indexOf(b));
    var est = b.closest('[data-dal-estimator]');
    if (est) { var r = b.querySelector('[data-dal-garment]'); if (r) { r.checked = true; est.dispatchEvent(new Event('change')); } }
    var track = b.closest('[data-dal-track]');
    if (track) track.scrollTo({ left: b.offsetLeft - track.offsetLeft, behavior: 'auto' });
    var faq = b.tagName === 'DETAILS' ? b : null;
    if (faq) faq.open = true;
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
})();
